document.addEventListener("DOMContentLoaded", function () {
  // Visitor Counter
  const visitorCount = Math.floor(Math.random() * 10000);
  document.getElementById("visitor-count").textContent = visitorCount;

  // Click Effects
  document.addEventListener("click", function (e) {
    const sparkle = document.createElement("span");
    sparkle.textContent = "✨"; // Or '*', '🌟', etc.
    sparkle.style.position = "absolute";
    sparkle.style.left = e.clientX + "px";
    sparkle.style.top = e.clientY + "px";
    sparkle.style.fontSize = "20px";
    sparkle.style.pointerEvents = "none"; // Allow clicks to pass through
    sparkle.style.opacity = "1";
    sparkle.style.transition = "all 0.5s ease-out";
    sparkle.style.transform = "scale(1)";
    sparkle.style.zIndex = "9999";

    document.body.appendChild(sparkle);

    setTimeout(() => {
      sparkle.style.opacity = "0";
      sparkle.style.transform = "scale(1.5)";
    }, 50);

    setTimeout(() => {
      sparkle.remove();
    }, 550);
  });
});
